import React, { Component } from 'react';
import ReportPage from './ReportPage';

class TitlePage extends Component {
    render() {        
        let pf = this.props.preparedFor ? this.props.preparedFor.replace(/\n/g, '<br class="ignore"/>') : '';
        let pb = this.props.preparedBy ? this.props.preparedBy.replace(/\n/g, '<br class="ignore"/>') : '';
        return (
            <ReportPage {...this.props} title="" className="title-page">
                <h4>{new Date().toLocaleDateString()}</h4>
                <h1>Target-Date Blueprint</h1>
                <div className="branding">
                    <h2>Analysis prepared for:</h2>
                    { !this.props.logo ? <h3 className="preparedFor" dangerouslySetInnerHTML={{__html: pf }} /> : null }
                    { this.props.logo ? <img src={this.props.logo} alt="Company Logo"/> : null }
                </div>
                <div className="byline">
                    <h5>Prepared By</h5>                    
                    { !this.props.adviserLogo ? <h6 className="preparedBy" dangerouslySetInnerHTML={{__html: pb }} /> : null }
                    { this.props.adviserLogo ? <img src={this.props.adviserLogo} alt="Adviser Logo"/> : null }
                </div>
            </ReportPage>
        );
    }
}

export default TitlePage;
